import standardAPI from '@/api/standard_items';

const responseUrl = '/blog/categories';

const state = {
  categories: [],
  categories_MetaData: {},
  categories_status: '',
  categories_page: 1,
  categories_perPage: 10,
};

const getters = {
  get_categories: (state) => {
    return state.categories;
  },
  get_categories_status: (state) => {
    return state.categories_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_categories ({ commit }, getOptions) {
    commit('DATA_CATEGORIES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_CATEGORIES_UPDATE_SUCCESS', response);
            commit('DATA_CATEGORIES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_CATEGORIES_READY');
            reject(response);
          } else {
            commit('DATA_CATEGORIES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_categories_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_category ({ commit, dispatch }, itemData) {
    commit('DATA_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_CATEGORIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  edit_category ({ commit, dispatch }, itemData) {
    commit('DATA_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_CATEGORIES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  remove_categories ({ commit, dispatch }, itemData) {
    commit('DATA_CATEGORIES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_CATEGORIES_REQUEST');
          resolve();
        } else {
          commit('DATA_CATEGORIES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_category ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve();
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.categories_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.categories_perPage = max;
  },
  DATA_CATEGORIES_READY: (state) => {
    state.categories_status = 'ready';
  },
  DATA_CATEGORIES_REQUEST: (state) => {
    state.categories_status = 'loading';
  },
  DATA_CATEGORIES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.categories_MetaData.meta = response.meta;
      state.categories_MetaData.links = response.links;
    }
    state.categories = response.data;
    state.categories_status = 'success';
  },
  DATA_CATEGORIES_ERROR: (state) => {
    state.categories_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
